import { AlertTriangle } from "lucide-react";

import { Button } from "@/components/ui/button";

// Styles Constants based on Figma Design
const STYLES = {
  errorMessage: {
    fontSize: "12px",
    lineHeight: "20px",
    color: "#FF0000",
    whiteSpace: "pre-line" as const
  },
  button: {
    width: "108px",
    height: "32px",
    padding: "7px 0",
    background: "#FFFFFF",
    border: "2px solid #0068B8",
    boxShadow: "0px 10px 10px rgba(0, 0, 0, 0.25)",
    fontSize: "15px",
    lineHeight: "15px",
    color: "#0068B8",
    borderRadius: "4px"
  }
} as const;

interface EmailErrorPageProps {
  errorMessage?: string;
  onBack: () => void;
}

const EmailErrorPage = ({
  errorMessage = "پست الکترونیکی وارد شده در سامانه ثبت نشده یا اشتباه است.\nلطفاً صحت آدرس وارد شده را بررسی نموده و در صورت نیاز، مجدداً تلاش فرمایید.\nدر صورت ادامه مشکل، با پشتیبانی سامانه تماس حاصل نمایید.",
  onBack
}: EmailErrorPageProps) => {
  return (
    <div className="w-full space-y-6 sm:space-y-8">
      {/* Error Icon */}
      <div className="flex justify-center">
        <AlertTriangle size={60} color="#FF0404" fill="none" strokeWidth={2} />
      </div>

      {/* Error Message */}
      <div className="space-y-4">
        <p
          className="text-right font-normal leading-relaxed"
          style={STYLES.errorMessage}
        >
          {errorMessage}
        </p>
      </div>

      {/* Back Button */}
      <div className="flex justify-center">
        <Button
          onClick={onBack}
          className="font-normal transition-opacity hover:opacity-90"
          style={STYLES.button}
          variant="outline"
        >
          بازگشت
        </Button>
      </div>
    </div>
  );
};

export default EmailErrorPage;
